module.exports = (__webpack_require__(0))(37);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/views/widgets/AccessWidget.js from dll-reference girder_lib
// module id = 44
// module chunks = 0